import {
    SYSTEM_LISTS_LOADING,
    SYSTEM_LISTS_ERRORS,
    FETCH_COMMODITIES_SUCCESS,
    SYSTEM_LISTS_GET_EMPLOYMENT_TYPES,
    SYSTEM_LISTS_GET_EMPLOYMENT_STATUS,
    SYSTEM_LISTS_GET_LANGUAGES,
    SYSTEM_LISTS_GET_APPLIED_FOR,
    SYSTEM_LISTS_GET_WORK_HOURS_AVAILABILITY,
    SYSTEM_LISTS_GET_TRAVEL_TYPES
} from "actions/types";

const initialState = {
    commodities: [],
    loading: false,
    error: {},

    employmentTypes: [],
    employmentStatus: [],
    languages: [],
    appliedFor: [],
    workHoursAvailability: [],
    travelTypes: []
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SYSTEM_LISTS_LOADING:
            return {
                ...state,
                loading: true,
                error: {},
            };
        case SYSTEM_LISTS_ERRORS:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        case FETCH_COMMODITIES_SUCCESS:
            return {
                ...state,
                commodities: action.payload,
                loading: false
            };
        case SYSTEM_LISTS_GET_EMPLOYMENT_TYPES:
            return {
                ...state,
                loading: false,
                employmentTypes: action.payload
            };
        case SYSTEM_LISTS_GET_EMPLOYMENT_STATUS:
            return {
                ...state,
                loading: false,
                employmentStatus: action.payload
            };
        case SYSTEM_LISTS_GET_LANGUAGES:
            return {
                ...state,
                loading: false,
                languages: action.payload
            };
        case SYSTEM_LISTS_GET_APPLIED_FOR:
            return {
                ...state,
                loading: false,
                appliedFor: action.payload
            };
        case SYSTEM_LISTS_GET_WORK_HOURS_AVAILABILITY:
            return {
                ...state,
                loading: false,
                workHoursAvailability: action.payload
            };
        case SYSTEM_LISTS_GET_TRAVEL_TYPES:
            return {
                ...state,
                loading: false,
                travelTypes: action.payload
            };
        default:
            return state;
    }
}
